const IS_FEATURE_ENABLED = 'featureToggles/isFeatureEnabled'

const _state = {
  createdPresentationFromOnBoarding: false,
}

const _getters = {
  canUseNewKickstartScreen: (_, __, ___, rootGetters) => {
    return rootGetters[IS_FEATURE_ENABLED]('release-AHA-37344-blank-presentation')
  },
  canUseOnBoardingKickstartScreen: (_, __, ___, rootGetters) => {
    return rootGetters[IS_FEATURE_ENABLED]('release-AHA-37361-on-boarding-blank-presentation')
  },
  isNewKickstartScreen: (_, getters, rootState) => {
    return !!(getters.canUseNewKickstartScreen &&
      rootState.isNewPresentation && rootState.presentation?.slides?.every((s) => !s?.type))
  },
}

const mutations = {
  setCreatedPresentationFromOnBoarding(state, value) {
    state.createdPresentationFromOnBoarding = value
  },
}

const actions = {
  resetKickstartScreenStateAction: ({
    dispatch, rootState, state, rootGetters,
  }) => {
    if (rootGetters['rightNav/rightNavActiveTab']) {
      dispatch('rightNav/setRightNavActiveTabAction', null, { root: true })
    }
    if (rootState.isShowingSlideSearchPopup && !state.createdPresentationFromOnBoarding) {
      dispatch('setSlideSearchPopupVisibilityAction', false, { root: true })
      dispatch('patchPresentationAction', { isShowingSlideSearch: false }, { root: true })
    }
  },
  setCreatedPresentationFromOnBoardingAction: ({ commit }, value) => {
    commit('setCreatedPresentationFromOnBoarding', value)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
